import { LuX } from '@react-icons/all-files/lu/LuX'
import React, { useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { sendMixpanelEvent } from '@disco/state-management/actions/AnalyticsActions'
import { savePlaylistMetadata } from '@disco/state-management/actions/ServerActions'
import { getPlaylist } from '@disco/state-management/selectors/playlists'

import {
  Button,
  Dialog,
  Flex,
  IconButton,
  Text,
  TextField,
} from 'components/ds'

import { useDispatch, useSelector } from 'hooks/use-redux'

// SLAM-1939: Use React.JSX for React 19 compatibility.
const EditMetadata = (): React.JSX.Element => {
  const navigate = useNavigate()
  const { playlistId } = useParams<{ playlistId: string }>()
  const dispatch = useDispatch()

  const playlist = useSelector(state =>
    getPlaylist(state, { id: parseInt(playlistId, 10) }),
  )
  const saving = useSelector(state => state.server.saving)

  const [name, setName] = useState(playlist?.name ?? '')

  const trimmedName = name.trim()
  const canSubmit =
    !saving && trimmedName.length > 0 && trimmedName !== playlist?.name

  const closeModal = () => navigate('/')

  const handleSubmit = () => {
    if (!canSubmit) return

    dispatch(savePlaylistMetadata(playlist, { name: trimmedName })).then(() => {
      dispatch(sendMixpanelEvent('Rename playlist'))
      closeModal()
    })
  }

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      handleSubmit()
    }
  }

  return (
    <Dialog.Root open onOpenChange={open => !open && closeModal()}>
      <Dialog.Content maxWidth="400px" aria-describedby={undefined}>
        <Flex justify="between" align="center">
          <Dialog.Title mt="0" mb="0">
            Rename playlist
          </Dialog.Title>
          <Dialog.Close>
            <IconButton variant="ghost" color="gray" aria-label="Close">
              <LuX size={16} />
            </IconButton>
          </Dialog.Close>
        </Flex>
        <Flex direction="column" gap="1" mt="4">
          <Text as="label" size="2" color="gray">
            Name
          </Text>
          <TextField.Root
            autoFocus
            disabled={saving}
            placeholder="Playlist name"
            value={name}
            onChange={e => setName(e.target.value)}
            onKeyDown={handleKeyDown}
          />
        </Flex>
        <Flex gap="2" mt="4" justify="end">
          <Dialog.Close>
            <Button variant="soft" color="gray" disabled={saving}>
              Cancel
            </Button>
          </Dialog.Close>
          <Button loading={saving} disabled={!canSubmit} onClick={handleSubmit}>
            Rename
          </Button>
        </Flex>
      </Dialog.Content>
    </Dialog.Root>
  )
}

export default EditMetadata
